import { RootState } from "../..";
import { MatchData, OpenOrderData } from "./types";

export const selectStockOpenOrderData = (state: RootState): OpenOrderData[] => state.user.stockOpenOrder.openOrderDatas;
export const selectStockOpenOrderLoading = (state: RootState):boolean => state.user.stockOpenOrder.loading;
export const selectStockMatchData = (state: RootState): MatchData[] => state.user.stockOpenOrder.matchDatas;
export const selectStockMatchLoading = (state: RootState):boolean => state.user.stockOpenOrder.matchLoading;
export const selectCancelOrderLoading = (state: RootState):boolean => state.user.stockOpenOrder.cancelLoading;
export const selectUpdateOrderLoading = (state: RootState):boolean => state.user.stockOpenOrder.updateLoading;
export const selectOrderLoading = (state: RootState):boolean => state.user.stockOpenOrder.orderLoading;